import { I18n } from '@calendly/i18n'

export const getLabelText = (kind) => ({
  ask_invitee: I18n.t('publisher.event_types.location.ask_invitee.label'),
  all_options: I18n.t('publisher.event_type_editor.sections.event_details.fields.location.dropdown.label'),
  no_location: I18n.t('publisher.event_type_editor.sections.event_details.location.no_location'),
  custom: I18n.t('publisher.event_types.location.custom.label'),
  google_conference: I18n.t('publisher.event_types.location.google_conference.label'),
  gotomeeting_conference: I18n.t('publisher.event_types.location.gotomeeting_conference.label'),
  physical: I18n.t('publisher.event_types.location.physical.label'),
  zoom_conference: I18n.t('publisher.event_types.location.zoom_conference.label'),
  inbound_call: I18n.t('publisher.event_types.location.inbound_call.label'),
  outbound_call: I18n.t('publisher.event_types.location.outbound_call.label'),
  microsoft_teams_conference: I18n.t('publisher.event_types.location.microsoft_teams_conference.label'),
  webex_conference: I18n.t('publisher.event_types.location.webex_conference.label'),
}[kind])
